import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export function initGraphSvg() {
	const graphItem = document.querySelector(".keynumbers__item--is-img svg");
	if (!graphItem) return;

	const dash1 = document.querySelector(".dash-1");
	const dash2 = document.querySelector(".dash-2");
	const dash3 = document.querySelector(".dash-3");
	const partGraph1 = document.querySelector(".part-graph-1");
	const partGraph2 = document.querySelector(".part-graph-2");
	const partGraph3 = document.querySelector(".part-graph-3");

	if (!dash1 && !dash2 && !dash3) return;

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: graphItem,
			start: "top 80%",
			// toggleActions: "play none none reverse",
			once: true,
			// invalidateOnRefresh: true
		},
		defaults: { ease: "power2.out" }
	});

	// Calcul dynamique de la longueur du path
	const length1 = dash1.getTotalLength();
	dash1.style.strokeDasharray = length1;
	dash1.style.strokeDashoffset = length1;
	const length2 = dash2.getTotalLength();
	dash2.style.strokeDasharray = length2;
	dash2.style.strokeDashoffset = length2;
	const length3 = dash3.getTotalLength();
	dash3.style.strokeDasharray = length3;
	dash3.style.strokeDashoffset = length3;

	// Étape 1 : Zoom-in + fade des éléments part-graph-1 à 3
	tl.from(partGraph1, { scale: 0.5, opacity: 0, duration: 0.2 })
		.from(partGraph2, { scale: 0.5, opacity: 0, duration: 0.2 }, "+=0.2")
		.from(partGraph3, { scale: 0.5, opacity: 0, duration: 0.2 }, "+=0.2")
		.from(".shadow", { opacity: 0, duration: 0.2 });

	// Étape 2 : dash-1 + contenu 1
	tl.to(dash1, { strokeDashoffset: 0, duration: 0.15 })
		.from(".part-content-1 .part-percent, .part-content-1 .part-name", {
			opacity: 0,
			duration: 0.15,
			stagger: 0.2
		});

	// Étape 3 : dash-2 + contenu 2
	tl.to(dash2, { strokeDashoffset: 0, duration: 0.15 })
		.from(".part-content-2 .part-percent, .part-content-2 .part-name", {
			opacity: 0,
			duration: 0.15,
			stagger: 0.2
		});

	// Étape 4 : dash-3 + contenu 3
	tl.to(dash3, { strokeDashoffset: 0, duration: 0.15 })
		.from(".part-content-3 .part-percent, .part-content-3 .part-name", {
			opacity: 0,
			duration: 0.15,
			stagger: 0.2
		});
}